import { defineStore } from 'pinia';
import { ref } from 'vue';
import { FormPartBData } from '../models/form-part-b-data';

export const useFormPartBDataStore = defineStore('FormPartBDataStore', () => {
  const formPartBData = ref({} as FormPartBData);

  function setFormPartBData(i: FormPartBData) {
    formPartBData.value = i;
  }

  function clearFormPartBData() {
    formPartBData.value = {} as FormPartBData;
  }

  return {
    formPartBData,
    setFormPartBData,
    clearFormPartBData,
  };
});
